import { Route, Redirect } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import Reports from "../pages/Reports";
import Landing from "../pages/Landing";
import ComingSoon from "../pages/ComingSoon";
import Login from "../pages/Login";
import UserManagement from "../pages/UserManagement";
import AppContext from "../providers/AppContext";
import { useContext } from "react";
import CustomPageNotFound from "../pages/CustomPageNotFound";
import GroupManagement from "../pages/GroupManagement";
import NewUser from "../pages/NewUser";
import EditUser from "../pages/EditUser";
import Locations from "../pages/Locations";
import IndividualLocations from "../pages/IndividualLocations";
import ResetPassword from "../pages/ResetPassword";

const NavigationRouter = () => {
  const { firebaseUserLogInInfo, jwt } = useContext(AppContext);

  return (
      <IonRouterOutlet mode="md" animated={false}>
        <Route
          exact
          path={"/login"}
          render={props => (firebaseUserLogInInfo ? <Redirect to={"/"} /> : <Login {...props} />)}
        />
        <Route
          exact
          path="/"
          render={props => (firebaseUserLogInInfo ? <Landing {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route exact path={"/emailpassreset"} render={props => <ResetPassword {...props} />} />
        <Route
          exact
          path="/reports"
          render={props => (firebaseUserLogInInfo ? <Reports {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route
          exact
          path="/locations"
          render={props => (firebaseUserLogInInfo ? <Locations {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route
          exact
          path="/individual-locations"
          render={props => (firebaseUserLogInInfo ? <IndividualLocations {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route
          exact
          path="/user-management"
          render={props => (firebaseUserLogInInfo ? <UserManagement {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route
          exact
          path="/group-management"
          render={props => (firebaseUserLogInInfo ? <GroupManagement {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route
          exact
          path="/edit-user"
          render={props => (firebaseUserLogInInfo ? <EditUser {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route
          exact
          path="/new-user"
          render={props => (firebaseUserLogInInfo ? <NewUser {...props} /> : <Redirect to={"/login"} />)}
        />
        <Route exact path="/coming-soon" component={ComingSoon} />
        <Route component={CustomPageNotFound} />
      </IonRouterOutlet>
  );
};

export default NavigationRouter;
